import { useState, useEffect } from "react";

const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Sobre mí", href: "#sobre-mi" },
  { label: "Servicios", href: "#servicios" },
  { label: "Testimonios", href: "#testimonios" },
  { label: "Blog", href: "#blog" },
  { label: "Contacto", href: "#contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0a0a0f]/95 backdrop-blur-md shadow-lg shadow-black/30"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#inicio"
          onClick={(e) => { e.preventDefault(); handleNavClick("#inicio"); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/9d8cfb7979fc745e2d4072c466ad6183/3ac0f563bfa6cda8ff586688bad6c56b.jpeg"
            alt="Albert Vidente Tarotista Logo"
            className="w-12 h-12 rounded-full object-cover border-2 border-[#c9a84c]"
          />
          <div className="hidden sm:block">
            <p className="text-[#c9a84c] font-serif text-lg font-bold leading-tight whitespace-nowrap">Albert Vidente</p>
            <p className="text-white/70 text-xs tracking-widest uppercase whitespace-nowrap">Tarotista Profesional</p>
          </div>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="px-4 py-2 text-white/80 hover:text-[#c9a84c] text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <a
          href="#contacto"
          onClick={(e) => { e.preventDefault(); handleNavClick("#contacto"); }}
          className="hidden md:block px-5 py-2 border border-[#c9a84c] text-[#c9a84c] text-sm font-semibold rounded-full hover:bg-[#c9a84c] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          Reservar Consulta
        </a>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0a0f]/98 backdrop-blur-md border-t border-white/10 px-4 py-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="block py-3 text-white/80 hover:text-[#c9a84c] text-base font-medium border-b border-white/5 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={(e) => { e.preventDefault(); handleNavClick("#contacto"); }}
            className="mt-4 block text-center px-5 py-3 border border-[#c9a84c] text-[#c9a84c] text-sm font-semibold rounded-full cursor-pointer"
          >
            Reservar Consulta
          </a>
        </div>
      )}
    </nav>
  );
}
